module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <ReporteAuxiliarCuenta-consultar></ReporteAuxiliarCuenta-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/reporteAuxiliarCuenta/reporteAuxiliarCuenta.component.html
// module id = ./src/app/Contabilidad/reporteAuxiliarCuenta/reporteAuxiliarCuenta.component.html
// module chunks = main